import Vue from 'vue'
import { liveStats, Topics } from '@/mqtt/liveStats'

const _state = {}

const mutations = {
  updateStats(state, statsUpdate) {
    Vue.set(state, statsUpdate.topic, statsUpdate.message)
  },
}

const actions = {
  subscribeStatsAction({ commit }, payload) {
    liveStats.subscribeStats(payload, (topic, message, statsUpdate) => {
      commit('updateStats', {
        topic,
        message,
      })
      if (payload.callback) {
        payload.callback(statsUpdate)
      }
    })
  },
  unsubscribeStatsAction(_, payload) {
    liveStats.unsubscribeStats(payload)
  },
}

const getters = {
  answerCountPerAnswerValue(state) {
    return (activityId, questionId, version, answerValue) => {
      return state[Topics.answerCountPerAnswerValueTopic(activityId, questionId, version, answerValue)]
    }
  },
  answerCountPerActivity(state) {
    return (activityId, version) => {
      return state[Topics.answerCountPerActivityTopic(activityId, version)]
    }
  },
  answererCountPerQuestion(state) {
    return (activityId, questionId, version) => {
      return state[Topics.answererCountPerQuestionTopic(activityId, questionId, version)]
    }
  },
  averageScorePerQuestion(state) {
    return (activityId, version, questionId) => {
      return state[Topics.averageScorePerQuestionTopic(activityId, version, questionId)]
    }
  },
  averageScorePerActivity(state) {
    return (activityId, version) => {
      return state[Topics.averageScorePerActivityTopic(activityId, version)]
    }
  },
  reactionCountPerType(state) {
    return (liveSessionId, version, reactionType) => {
      return state[Topics.reactionCountPerTypeTopic(liveSessionId, version, reactionType)]
    }
  },
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters,
}
